import { render, staticRenderFns } from "./SearchEngineCourses.vue?vue&type=template&id=f27d037c&scoped=true&"
import script from "./SearchEngineCourses.vue?vue&type=script&lang=js&"
export * from "./SearchEngineCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27d037c",
  null
  
)

export default component.exports